import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  AlignedGrid, QuoteComparisonExpansionPanel, createLoanGridElements, createLoanGridLabel,
  createLoanGridElementsWithRenderer,
  createMoneyLoanGridElements,
  RightAlignedDiv,
  createPeriodLoanGridElements,
  QuoteComparisonExpansionSummary,QuoteComparisonExpansionPanelDetails
} from './QuoteComparisonGridElements';
import numberFormatter from 'utils/numberFormatter';

class Reserves extends Component {
  state = {
    expanded:true
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }
  renderReserves = (field, valueProperty, measurementProperty) => {    
    return (loan,placeholder) => {
      if(loan[valueProperty] && loan[valueProperty].toString().indexOf("|")>-1) {
        
        const measurements = loan[measurementProperty].split("|");
        
        return loan[valueProperty].split('|').map((value, index) => {
          let measurement = measurements[index];
          if(measurement === 'SQUARE_FOOT')
          measurement = 'RSF';
        else 
          measurement = 'Unit';
          return !value && value !== 0 ?
                (<RightAlignedDiv>{placeholder}</RightAlignedDiv>)
                :
                (<React.Fragment key={`${field}-${index}`}>{`${numberFormatter.formatMoney(value, 2)} ${measurement}`}<br /></React.Fragment>);
        });
      } else {
        let value = loan[valueProperty];
        let measurement = loan[measurementProperty];
        if(measurement === 'SQUARE_FOOT')
          measurement = 'RSF';
        else 
          measurement = 'Unit';
        
        return !value && value !== 0 ?
                (<RightAlignedDiv>{placeholder}</RightAlignedDiv>)
                :
                `${numberFormatter.formatMoney(value, 2)} ${measurement}`;
      }
  }
  }
  renderTaxesAndInsurance = (loan) => {
    return loan["covenantsTaxReserve"] || loan["covenantsInsuranceReserve"] ? 'Yes' : 'No';
  }
  render() {
    const { loans,isCombined } = this.props;
    const { expanded } = this.state;
    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />} >
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Replacement Reserves")}
            {expanded && createLoanGridElementsWithRenderer(loans, this.renderReserves('replacementReserves', 'covenantsReplacementReserve', 'covenantsReplacementPerName'),'\u2014',isCombined)}
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            {createLoanGridLabel("Repair Reserves")}
            {createLoanGridElementsWithRenderer(loans, this.renderReserves('repairReserves', 'covenantsRepairReserve', 'covenantsRepairPerName'),'\u2014',isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("CapEx Reserves")}
            {createMoneyLoanGridElements(loans,'covenantsCapExReserves',isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Taxes / Insurance")}
            {createLoanGridElementsWithRenderer(loans, this.renderTaxesAndInsurance,'\u2014',isCombined)}
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default Reserves;